export const FLUTTER_CHANNEL = 'flutterChannel';
export const JS_CHANNEL = 'jsChannel';
